const CRM_ALLOWED_ADMIN_EMAILS = new Set([
  'marcio@marcio.com',
  'eliton_marcio@yahoo.com.br',
  'emersonm.deoliveiraj@gmail.com',
  'contato@viaboots.com.br'
]);

interface CrmAccessUser {
  role?: string | null;
  email?: string | null;
}

export const canAccessCrm = (user?: CrmAccessUser | null): boolean => {
  if (!user) return false;

  const normalizedEmail = (user.email || '').trim().toLowerCase();
  return CRM_ALLOWED_ADMIN_EMAILS.has(normalizedEmail);
};
